import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

function CpfInput({ id, inputRef, onChange, ...other }) {
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            id: id,
            value: values.value,
          },
        });
      }}
      format="###.###.###-##"
      mask="_"
    />
  );
}

CpfInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CpfInput;
